import { Text, type SystemStyleObject } from '@chakra-ui/react';

import { AGENT_THINKING_CHROME_COLOR } from './agentThinkingState';

type AgentThinkingChromeTextProps = {
  children: string;
  isLive?: boolean;
  noOfLines?: number;
};

const liveShimmerSx: SystemStyleObject = {
  backgroundImage:
    'linear-gradient(90deg, rgba(211, 190, 244, 0.35) 35%, #E8D9FF 50%, rgba(211, 190, 244, 0.35) 65%)',
  backgroundSize: '200% 100%',
  backgroundPosition: '200% center',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  color: 'transparent',
  animation: 'agentThinkingShimmer 1.6s linear infinite',
  '@keyframes agentThinkingShimmer': {
    from: { backgroundPosition: '200% center' },
    to: { backgroundPosition: '-200% center' },
  },
};

export function AgentThinkingChromeText({
  children,
  isLive = false,
  noOfLines,
}: AgentThinkingChromeTextProps) {
  return (
    <Text
      fontSize='xs'
      lineHeight='4'
      fontWeight='normal'
      noOfLines={noOfLines}
      color={isLive ? 'transparent' : AGENT_THINKING_CHROME_COLOR}
      sx={isLive ? liveShimmerSx : undefined}
    >
      {children}
    </Text>
  );
}
